const namespace = 'bravissimo/sidebar';

export const RECEIVE_SIDEBAR_CONTENT = `${namespace}/RECEIVE_SIDEBAR_CONTENT`;

export const GET_SIDEBAR_CONTENT_REQUEST = `${namespace}/GET_SIDEBAR_CONTENT_REQUEST`;
export const GET_SIDEBAR_CONTENT_FAILURE = `${namespace}/GET_SIDEBAR_CONTENT_FAILURE`;
export const GET_SIDEBAR_CONTENT_SUCCESS = `${namespace}/GET_SIDEBAR_CONTENT_SUCCESS`;
